import { setSearchTerm } from "../banksDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useBankSearch = () =>
  useSearch((s) => s.data.listing.banks.searchTerm, setSearchTerm);
